import { CommonUtilities } from '../../../commonUtils';

export default class songServices {

    static async SongListing(data: any) {
        var url = 'catalogue/projectAsset/listMyAsset?' + data;
        return CommonUtilities.getData(url);
    }

    static async AssociatedSongs(data: any) {
        console.log(data);
        var url = "publishing/song/associatedSongs/" + data.contractRefNum + "?pageNumber=" + data.pageNumber + "&pageSize=" + data.pageSize;
        return CommonUtilities.getData(url);
    }

    static SongContractAssets(data: any) {
        var url = 'catalogue/projectAsset/listMyassetContracts?' + data;
        console.log(data)
        return CommonUtilities.getData(url);
    }

    static async listMyassetContractsSong(data: any) {
        console.log(data);
        var url = "catalogue/projectAsset/listMyassetContracts?assetType=" + data.assetType +
            "&pageNumber=" + data.pageNumber + "&pageSize=" + data.pageSize + "&songCode=" + data.songCode;
        return CommonUtilities.getData(url);
    }

    static songSplitsCollSave(data: any) {
        var url = 'publishing/songSplitsColl/save';
        return CommonUtilities.postData(url, data);
    };

    static songReference() {
        var url = 'publishing/song/songReference/list';
        return CommonUtilities.getData(url);
    }

    static publishingSongSplitSave(data: any) {
        var url = 'publishing/songSplits/save';
        return CommonUtilities.postData(url, data);
    }

    static songSplitsCollList(data: any) {
        var url = 'publishing/songSplitsColl/list?' + CommonUtilities.buildQueryString(data, true, true);
        return CommonUtilities.getData(url);
    }

    static songSplitsCollectorDelete(dataId: any) {
        var url = 'publishing/songSplitsColl/delete/' + dataId;
        return CommonUtilities.getData(url);
    }

}